<template>
  <div class="h-full">
    <ui-nav-menu>
      <a href="/" rel="home" @click="navigate">Home</a>
      <a href="/widget" @click="navigate">Carousel Widget</a>
      <a href="/floating-widget" @click="navigate">Floating Badge Widget</a>
      <a href="/reviewgrid" @click="navigate">Grid Widget</a>
      <a href="/reviewlist" @click="navigate">List Widget</a>
      <a href="/automation" @click="navigate">Review Request</a>
      <a href="/reviews" @click="navigate">Reviews</a>
      <a href="/plan" @click="navigate">Plans</a>
    </ui-nav-menu>
    <router-view />
    <Notification
      v-if="loadNotification"
      :text="notificationText"
      :show="showNotification"
    />
  </div>
</template>
<script>
import Notification from "./components/Common/Notification.vue";
export default {
  components: {
    Notification
  },
  data() {
    return {
      notificationText: "",
      showNotification: false,
      loadNotification: false
    };
  },
  created() {
    this.$store.dispatch("initAppBridge").then(() => {
      this.subscribeToNavRedirect();
    });
    window.addEventListener("ToastNotify", event => {
      this.displayNotification(event.detail.text);
    });
  },
  mounted() {
    setTimeout(() => {
      this.loadNotification = true;
    }, 3000);
  },
  methods: {
    subscribeToNavRedirect() {
      console.log("app location", location);

      if (location.pathname && location.pathname != "/") {
        if (location.pathname.indexOf("/api/shopify/connect") > -1) {
          this.$router.push({ path: "/overview" });
        } else {
          this.$router.push({ path: location.pathname });
        }
      }
    },
    displayNotification(text) {
      this.showNotification = true;
      this.notificationText = text;
      setTimeout(() => {
        this.showNotification = false;
      }, 3000);
    },
    navigate(event) {
      event.preventDefault();
      history.pushState({}, null, event.target.href);
      this.$router.push({ path: event.target.pathname });
    }
  }
};
</script>

<style>
ui-nav-menu {
  display: none;
}
</style>
